module.exports = __webpack_public_path__ + "static/media/AM1018_lodgement_form_final.86e2bd75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/AM1018_lodgement_form_final.jpg
// module id = 1250
// module chunks = 0